import apiClient from './utils/apiClient';

const updateRequest = (id, data) => {
  return apiClient.post(`/requests/${id}`, data);
};

const getDailyOrderCounts = (date) => {
  return apiClient.get(`/admin/order-counts/${date}`);
};

const getDateRangeOrderCounts = (queryParams) => {
  return apiClient.get(`/admin/order-counts${queryParams}`);
};

// Chatbot API functions
const sendChatMessage = (message, conversationHistory = []) => {
  return apiClient.post('/chatbot/chat', { message, conversationHistory });
};

const placeChatOrder = (orderData) => {
  return apiClient.post('/chatbot/place-order', orderData);
};

// Individual acknowledgment
const acknowledgeIndividualOrder = (orderId) => {
  return apiClient.post(`/acknowledge/${orderId}`);
};

export { 
  updateRequest, 
  getDailyOrderCounts, 
  getDateRangeOrderCounts,
  sendChatMessage,
  placeChatOrder,
  acknowledgeIndividualOrder
};
export default apiClient;
